import { Pipe, PipeTransform } from '@angular/core';
import { ActivityDto } from '@bo-client/shared/models/activityDto';

@Pipe({
  name: 'openActivities'
})
export class OpenActivitiesPipe implements PipeTransform {
  transform(acitvities: ActivityDto[]) {
    if (acitvities) {
      if (acitvities.filter((x) => x.conversationState == 'GOT_ANSWER' && x.state != 'DONE').length > 0) {
        return 'Ja';
      }
    }
    return 'Nein';
  }
}
